// Imperative control for PageTransition, kept out of the component file so PageTransition
// only exports a component (react-refresh friendly).
//
// One-shot flag: lets an overlay (e.g. the account sheet) close without the underlying
// page replaying its horizontal slide — the sheet's own slide-down is the only motion.
let pendingSkip = false;

export const suppressNextPageTransition = (): void => {
  pendingSkip = true;
  // Safety: don't let the flag linger if the next page isn't wrapped in a transition.
  window.setTimeout(() => {
    pendingSkip = false;
  }, 400);
};

export const consumePageTransitionSkip = (): boolean => {
  const value = pendingSkip;
  pendingSkip = false;
  return value;
};
